import script from "./MfCollapse.vue?vue&type=script&setup=true&lang=js"
export * from "./MfCollapse.vue?vue&type=script&setup=true&lang=js"

import "./MfCollapse.vue?vue&type=style&index=0&id=5faa70dc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5faa70dc"]])

export default __exports__